<template>
  <ul :class="$style.filters">
    <li
      :class="{ [$style.current]: current === 'all' }"
      @click="() => action('all')"
    >
      Toutes
    </li>
    <li
      v-for="item in items"
      :key="item.slug"
      :class="{ [$style.current]: current === item.slug }"
      @click="handleClickItem(item)"
    >
      {{ capitalize(item.title) }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { Community } from '~/types'

const props = defineProps<{
  items: Partial<Community>[]
  current: string
  action: (slug: string) => void
}>()

const handleClickItem = (item: Partial<Community>) => {
  if (item.slug) {
    props.action(item.slug)
  }
}
</script>

<style lang="scss" module>
.filters {
  display: flex;
  align-items: flex-end;
  width: 100%;
  padding-right: 2.5rem;
  overflow-x: auto;
  list-style-type: none;
  scroll-snap-type: x proximity;

  @media (min-width: 700px) {
    flex-wrap: wrap;
    width: calc(100% + 2.5rem);
    margin: 0 -1.2rem;
    padding: 0;
  }

  li {
    flex-shrink: 0;
    margin-bottom: 2.5rem;
    padding-left: 2.5rem;
    font-size: 2.2rem;
    font-weight: 500;
    line-height: 2.9rem;
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.35s ease-in-out;
    user-select: none;
    scroll-snap-align: start;

    @media (min-width: 700px) {
      padding: 0 1.2rem;
    }

    &:hover:not(.current) {
      opacity: 0.85;
    }

    &.current {
      opacity: 1;
    }
  }
}
</style>
